import { homepage } from '../../../package.json';
import { GET } from 'utils/http';

export const fetchAppConfig = async () => {
	return await GET({ url: 'configs/app.json', baseURL: window.location.origin + homepage });
};

export const getTenantTheme = async (tenantName) => {
	return await import(`../../../configs/tenant/${tenantName}/theme.js`);
};

export const getTenantStrings = async (tenantName) => {
	return await GET({
		url: `configs/tenant/${tenantName}/strings.json`,
		baseURL: window.location.origin + homepage,
	});
};
